import { isHex } from 'viem';

function isHexList(list) {
  return list.every((value) => isHex(value));
}
function exhaustiveGuard(_value) {
  throw new Error(`Exhaustive guard reached with value ${_value}`);
}
function nowUnixTimestamp() {
  return Math.floor(Date.now() / 1e3);
}
function BigIntMin(...[firstValue, ...values]) {
  let value = firstValue;
  for (const currentValue of values) {
    if (currentValue < value)
      value = currentValue;
  }
  return value;
}
function BigIntMax(...[firstValue, ...values]) {
  let value = firstValue;
  for (const currentValue of values) {
    if (currentValue > value)
      value = currentValue;
  }
  return value;
}
function scaleAmount({ amount, multiplier }) {
  return amount * BigInt(multiplier * 100) / 100n;
}
function curry(fn) {
  return function curried(...args) {
    if (args.length >= fn.length) {
      return fn(...args);
    } else {
      return (...args2) => curried(...args, ...args2);
    }
  };
}
async function wait(duration) {
  return new Promise((resolve) => setTimeout(resolve, duration));
}
async function retryAsync(fn, { attempts, interval, onError }) {
  let currentTry = 0;
  let latestError;
  while (currentTry < attempts) {
    try {
      currentTry += 1;
      const result = await fn({
        attempt: currentTry,
        isFinalAttempt: currentTry === attempts
      });
      return result;
    } catch (error) {
      onError?.({ error, currentTry });
      latestError = error;
      if (currentTry < attempts) {
        await wait(interval);
      }
    }
  }
  throw latestError || new Error(`Invalid attempts: ${attempts}`);
}

export { BigIntMax, BigIntMin, curry, exhaustiveGuard, isHexList, nowUnixTimestamp, retryAsync, scaleAmount };
